import dayjs from 'dayjs';

// A link that opens one duty on the schedule - its site, its week, the duty selected and open for
// editing (schedule.page.jsx reads ?duty=&site=&date=). Used by the dashboard's record lists, which
// open it in a new tab so the list stays where it was.
const link = (dutyId, siteId, date) => (dutyId && siteId
  ? `/user/schedule?duty=${encodeURIComponent(dutyId)}&site=${encodeURIComponent(siteId)}&date=${encodeURIComponent(date || dayjs().format('DD/MM/YYYY'))}`
  : null);

// a row from getScheduleDashboardDetail (the duty itself)
export const dutyRowHref = (row) => link(row?._id, row?.siteId, row?.date || (row?.firstDate ? dayjs(row.firstDate).format('DD/MM/YYYY') : null));

// a pending task / checkpoint row (belongs to a duty)
export const dutyOfRowHref = (row) => link(row?.scheduleId, row?.siteId, row?.dutyDate);
